<script setup lang="ts">
import { InfoCircleIcon } from "@gohighlevel/ghl-icons/24/outline";
import { UIAlert, UITooltip } from "@gohighlevel/ghl-ui";
import { HLContentWrap, HLToggle } from "@platform-ui/highrise";
import { useI18n } from "vue-i18n";

defineProps<{
  hasAddressField: boolean;
  billingEnabled: boolean;
}>();

const emit = defineEmits<{
  (event: "update:billing", value: boolean): void;
}>();

const { t } = useI18n();
</script>

<template>
  <HLContentWrap full-screen namespace="formSurveyApp">
    <div class="flex flex-col gap-4 pt-2">
      <UIAlert id="shipping-address-info" type="default" :closable="false">
        <template #content>{{ t("common.sellProductsAddress.shippingAddressDescription") }}</template>
      </UIAlert>

      <div class="flex items-start gap-3">
        <div class="min-w-0 flex-1">
          <div class="flex items-center gap-2">
            <div id="billing-address-label" class="text-sm font-normal text-gray-900">
              {{ t("common.sellProductsAddress.billingAddress") }}
            </div>
            <UITooltip
              v-if="!hasAddressField"
              width="300px"
              trigger="hover"
              placement="top"
            >
              <template #trigger>
                <InfoCircleIcon class="h-4 w-4 text-gray-400" />
              </template>
              {{ t("common.sellProductsAddress.billingRequiresAddress") }}
            </UITooltip>
          </div>
          <span v-if="!hasAddressField" id="billing-address-dependency" class="sr-only">
            {{ t("common.sellProductsAddress.billingRequiresAddress") }}
          </span>
        </div>
        <HLToggle
          id="billing-address-toggle"
          size="sm"
          :value="billingEnabled && hasAddressField"
          :disabled="!hasAddressField"
          aria-labelledby="billing-address-label"
          :aria-describedby="!hasAddressField ? 'billing-address-dependency' : undefined"
          @update:value="emit('update:billing', $event === true)"
        />
      </div>
    </div>
  </HLContentWrap>
</template>
